import * as React from 'react';
import { Swiper, SwiperProps, SwiperSlide } from 'swiper/react';
import { Pagination, Virtual } from 'swiper/modules';

type FullPageSliderProps = SwiperProps;

const FullPageSlider: React.FC<FullPageSliderProps> = (props) => {
    if (!props.children) {
        return null;
    }

    const slides = React.Children.toArray(props.children).filter(Boolean);

    return (
        <Swiper {...props} modules={[Pagination, Virtual]}>
            {slides.map((slideContent, index) => (
                <SwiperSlide key={index} virtualIndex={index}>
                    {slideContent}
                </SwiperSlide>
            ))}
        </Swiper>
    );
};

export default FullPageSlider;
